import type { AppointmentItem, ExternalEvent } from "@nmt/shared";
import { appointmentWhen } from "./schedule";
import { Dialog } from "./ui";

/** Events from other calendars ride along as appointment-shaped items with an "ext:" id. */
export const isExternal = (a: AppointmentItem) => a.id.startsWith("ext:");
export function asItem(e: ExternalEvent): AppointmentItem {
  // All-day events come as dates (midnight UTC, end exclusive): shown on those days here.
  const local = (iso: string, back = 0) => {
    const d = new Date(iso);
    return new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate() - back).toISOString();
  };
  return {
    id: `ext:${e.id}`,
    title: e.mine ? e.title : `${e.userName.split(" ")[0]}: ${e.title}`,
    type: "",
    startsAt: e.allDay ? local(e.startsAt) : e.startsAt,
    endsAt: e.allDay ? local(e.endsAt, 1) : e.endsAt,
    allDay: e.allDay,
    location: e.location,
    notes: "",
    attendees: [{ id: e.userId, name: e.calendar ?? e.userName, color: e.color, active: true, googleSynced: false, googleError: null }],
    createdBy: null,
    weather: null,
    jobId: null,
    jobNumber: null,
    contactId: null,
    contactName: null,
  } as unknown as AppointmentItem;
}

/** An event from another calendar: read-only here. */
export function ExternalDialog({ e, onClose }: { e: ExternalEvent; onClose: () => void }) {
  const when = asItem(e);
  return (
    <Dialog title={e.title} onClose={onClose}>
      <div className="flex flex-col gap-2 text-sm">
        <div>{appointmentWhen(when)}</div>
        {e.location && <div className="text-ink-soft">{e.location}</div>}
        <div className="text-muted">{e.mine ? `From your ${e.calendar} calendar. Change it there.` : `${e.userName}'s calendar${e.title === "Busy" ? " (shared as busy only)" : ""}.`}</div>
        {e.link && (
          <a href={e.link} target="_blank" rel="noreferrer" className="font-semibold text-brand hover:underline">
            Open it
          </a>
        )}
      </div>
    </Dialog>
  );
}

